console.debug("INFO main.js loaded");
document.addEventListener("DOMContentLoaded", function () {

    // DMP-3696 Click/Key on search focuses input, when dropdown is opened
    var searchBtn = document.getElementById("search-nav");
    var searchPanel = document.getElementById("search-nav-dropdown");
    var searchInput = searchPanel ? searchPanel.querySelector(".js-search-input") : null;

    function focusSearchIfOpen() {
        if (!searchBtn || !searchInput) return;
        var expanded = searchBtn.getAttribute("aria-expanded") === "true";
        if (!expanded) return;
        // wait after open for frame, than focus
        requestAnimationFrame(function () {
            // preventScroll
            if (searchInput.focus) searchInput.focus({ preventScroll: true });
            if (searchInput.select) searchInput.select();
        });
    }

    if (searchBtn && searchInput) {
        // Focus after click
        searchBtn.addEventListener("click", function () {
            // Toggle passiert meist im gleichen Tick – danach fokussieren
            setTimeout(focusSearchIfOpen, 200);
        });

        // Focus after keydown (Enter/Space)
        searchBtn.addEventListener("keydown", function (e) {
            var isActivationKey = e.key === "Enter" || e.key === " " || e.code === "Space";
            if (isActivationKey) {
                setTimeout(focusSearchIfOpen, 200);
            }
        });

        // in case aria-expanded is async set observer to focus input
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if (m.attributeName === "aria-expanded") {
                    focusSearchIfOpen();
                }
            });
        });
        observer.observe(searchBtn, { attributes: true, attributeFilter: ["aria-expanded"] });
    } else {
        console.debug("Debug: main.js: search button or input missing.");
    }


    // DMP-1103 removes empty .o-component-wrappers from html
  var o_component_wrappers = document.querySelectorAll(".o-component-wrapper");
  o_component_wrappers.forEach(function (item) {
    if (item.innerHTML.trim() === '') {
      item.remove();
    }
  });

});

document.addEventListener('bronson_panelchanged', function () {
  // do an additional resize-calculation for compare-and-select within the tabitem when the tab is changed
  document.querySelectorAll(".c-tabs__content[aria-hidden='false']").forEach(
      function (contentTabItem) {
        contentTabItem.querySelectorAll(".js-compare-and-select").forEach(
            function (compareAndSelect) {
              window.bronson.libs.Flickity(compareAndSelect).resize();
            });
      });
});

['DOMContentLoaded'].forEach(function (type) {
  document.addEventListener(type, function () {
    // DMP-12554 Cookie Consent Link
    // Open cookie consent tool by clicking on a link with href '#cookieconsent#
    var cookieConsentLinks = document.querySelectorAll(
        'a[href="#cookieconsent"]');
    cookieConsentLinks.forEach(function (cookieConsentLink) {
      cookieConsentLink.addEventListener('click', function (event) {
        event.preventDefault();
        if (window.CookieControl) {
          window.CookieControl.open();
        }
      });
    });
  });
});

function refreshHash() {
  if (!navigator.userAgent.includes("Firefox")) {
    var hash = window.location.hash;
    window.location.hash = '';
    window.location.hash = hash;
  }
}

window.onload = () => {
  if (!window.location.hash) {
    return;
  }

  refreshHash();

  var panels = document.querySelectorAll(".js-accordion__panel");
  if (panels && panels.length > 0) {
    var observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === "class"
            && mutation.target.classList.contains("is-collapsed")) {
          refreshHash()
          observer.disconnect();
        }
      })
    })

    observer.observe(panels[panels.length - 1], {attributes: true});
    setTimeout(() => observer.disconnect(), 2000);
  }
};

document.addEventListener("trackingParamsSet", function () {
  // DMP-6402 logic to manipulate URL parameters
  var links = document.querySelectorAll("a");
  links.forEach(function (link) {
    var href = link.getAttribute("href");
    // If the href is empty or doesn't contain query params, skip this link
    if (!href || (href && href.indexOf("?") === -1)) {
      return;
    }

    // Split the whole link into the blank link and the parameters
    var parameterString = href.split("?")[1];
    var newLink = href.split("?")[0] + "?";
    var parameters = parameterString.split("&");

    // Iterate over each parameter
    parameters.forEach(function (parameter, index) {
      // Split parameters into key value pairs
      var key = parameter.split("=")[0];
      var value = parameter.split("=")[1];
      if (!key || !value) {
        return;
      }
      var isPlaceholder = value.startsWith("((") && value.endsWith("))");

      // Skip parameter if it contains a placeholder, but there is not window.tracking object
      if (isPlaceholder && !window.tracking) {
        return;
      }

      // Logic to replace the placeholder with the actual analytics value
      if (isPlaceholder) {
        var clearValue = value.substring(2, value.length - 2);
        var dataLayerValue = window.tracking.params[clearValue];
        if (dataLayerValue) {
          value = dataLayerValue;
        } else {
          return;
        }
      }

      // Append the parameter to the blank link
      newLink += key + "=" + value + "&";
    });

    // Trim the link if there is an unnecessary "&" oder "?" at the end
    newLink = newLink.endsWith("?") || newLink.endsWith("&") ? newLink.substr(0,
        newLink.length - 1) : newLink;

    // Set the new href on the link
    link.setAttribute("href", newLink);

  });
});
